import React from "react"
import PropTypes from "prop-types"
import {
  CardTitle,
  FormGroup,
  Container,
  CardBody,
  Form,
  Input,
  Label,
} from "reactstrap"
import CustomAlert from "../layout/CustomAlert"
import { connect } from "react-redux"
import { Trans, useLingui } from "@lingui/react"
import { setCurrentPage } from "../../store/reducers/navigation"
import { t } from "@lingui/macro"
import { fetchVsla } from "../../store/actions/getVslas"
import { createFundAccounts } from "../../store/actions/FundAccounts"
import { isCreatingFundAccount } from "../../store/actions/FundAccounts/createFundAccounts"

const headerStyle = {
  color: "#E36F1E",
  fontFamily: "quicksand",
  fontWeight: "bolder",
  fontSize: "1.8em",
  textAlign: "center",
  // paddingBottom: "0.5em",
  paddingTop: "34px",
}

const loadingStyle = {
  fontFamily: "Fira Sans",
  fontSize: "20px",
}

const AddGroupFund = (props) => {
  const { i18n } = useLingui()
  const [state, setState] = React.useState({
    welfare: "welfare",
    fine: "fine",
    loanInterest: "loan_interest",
    membership: "membership",
    agri: "agri",
    loading: false,
    types: new Set(["welfare", "loan_interest", "fine", "membership", "agri"]),
  })

  const onChange = (e) => {
    if (getItemCheckedStatus(e.target.value)) removeItem(e.target.value)
    else setState({ ...state, types: new Set(state.types.add(e.target.value)) })
  }

  const onSubmit = (e) => {
    e.preventDefault()
    props.setPayloadData({ accounts: Array.from(state.types), funds: Array.from(state.types) })
  }


  const getItemCheckedStatus = (item) => state.types.has(item)

  const removeItem = (item) => {
    const newChecked = state.types
    newChecked.delete(item)
    setState({ ...state, types: new Set(newChecked) })
  }

  return (
    <Container>
      <CardTitle>
        <h4 className="textStyle" style={headerStyle}>
          <Trans id="title_copy.addFundAccount" />
        </h4>
      </CardTitle>
      <CustomAlert color="warning">
        <span
          style={{
            fontFamily: "Fira Sans",
            fontSize: "16px",
          }}
        >
          <Trans id="notifications.savings_fund_mandatory" />
        </span>
      </CustomAlert>
      <CardBody>
        <Form onSubmit={onSubmit}>
          <FormGroup
            check
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Label check>
              <Input
                disabled={true}
                type="checkbox"
                checked={true}
                onChange={onChange}
              />
              <h5 className="textStyle" style={loadingStyle}>
                <Trans id="menu.savingsFund" />
              </h5>
            </Label>
          </FormGroup>

          {!["ar", "lb"].includes(i18n.locale) && (
            <>
              <FormGroup
                check
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Label check>
                  <Input
                    type="checkbox"
                    name="welfare"
                    id="welfare"
                    onChange={onChange}
                    checked={getItemCheckedStatus(state.welfare) ? true : false}
                    value={state.welfare}
                  />
                  <h5 className="textStyle" style={loadingStyle}>
                    <Trans id="menu.welfareFund" />
                  </h5>
                </Label>{" "}
              </FormGroup>
              <FormGroup
                check
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Label check>
                  <Input
                    type="checkbox"
                    name="loanInterest"
                    id="loanInterest"
                    checked={getItemCheckedStatus(state.loanInterest) ? true : false}
                    onChange={onChange}
                    value={state.loanInterest}
                  />
                  <h5 className="textStyle" style={loadingStyle}>
                    <Trans id="menu.loanInterestFund" />
                  </h5>
                </Label>{" "}
              </FormGroup>
              <FormGroup
                check
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Label check>
                  <Input
                    type="checkbox"
                    name="fine"
                    id="fine"
                    checked={getItemCheckedStatus(state.fine) ? true : false}
                    onChange={onChange}
                    value={state.fine}
                  />
                  <h5 className="textStyle" style={loadingStyle}>
                    <Trans id="menu.fineFund" />
                  </h5>
                </Label>{" "}
              </FormGroup>
              <FormGroup
                check
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Label check>
                  <Input
                    type="checkbox"
                    name="membership"
                    id="membership"
                    checked={getItemCheckedStatus(state.membership) ? true : false}
                    onChange={onChange}
                    value={state.membership}
                  />
                  <h5 className="textStyle" style={loadingStyle}>
                    <Trans id="menu.membershipFund" />
                  </h5>
                </Label>{" "}
              </FormGroup>
                <FormGroup
                check
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Label check>
                  <Input
                    type="checkbox"
                    name="agri"
                    id="agri"
                    checked={getItemCheckedStatus(state.agri) ? true : false}
                    onChange={onChange}
                    value={state.agri}
                  />
                  <h5 className="textStyle" style={loadingStyle}>
                    <Trans id="menu.agriFund" />
                  </h5>
                </Label>{" "}
              </FormGroup>
            </>
          )}
          <hr />
          <FormGroup>
            <Input
              type="submit"
              value={t({ id: "placeholder_copy.create_fund_submit" })}
              name="submit"
              className="btn btn-primary"
            />
          </FormGroup>
        </Form>
      </CardBody>
    </Container>
  )
}

AddGroupFund.propTypes = {
  setPayloadData: PropTypes.func,
  vsla: PropTypes.object,
  existingVsla: PropTypes.object,
  setPage: PropTypes.func,
  setAccountsLoader: PropTypes.func,
  isCreatingVsla: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    vsla: state.vslaCreated,
    existingVsla: state.vsla,
    isCreatingVsla: state.isCreatingVsla,
  }
}
const mapDispatchToProps = (dispatch) => ({
  reloadVsla: () => dispatch(fetchVsla()),
  setPage: (page) => dispatch(setCurrentPage(page)),
  createAccounts: (types) => dispatch(createFundAccounts(types)),
  setAccountsLoader: (val) => dispatch(isCreatingFundAccount(val)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AddGroupFund)
